export var MISSIONS_ACTIONS = {
  FINISH_TUTORIAL: 'FINISH_TUTORIAL',
  START_MISSION: 'START_MISSION',
  CLAIM_MISSION_REWARD: 'CLAIM_MISSION_REWARD'
};